/* eslint-disable no-prototype-builtins */
import React, { useState } from 'react'
import { DeleteOutlined, CloseOutlined, PlusOutlined } from '@ant-design/icons'
import { useImmer } from 'use-immer'
import PropTypes from 'prop-types'
import cloneDeep from 'lodash/cloneDeep'
import Dropdown from '../common/Dropdown'
import ArrayParams from '../common/ArrayParams'
import ObjectParams from '../common/ObjectParams'
import Code from '../common/Code'

/**
 * ExampleComponent is an example component.
 * It takes a property, `label`, and
 * displays it.
 * It renders an input with the property `value`
 * which is editable by the user.
 */
const Model = (props) => {
    // eslint-disable-next-line react/prop-types
    const { id, className, isEdit, options, content, children, setProps } = props

    let methodOptions = []
    let stepOptions = []

    try {
        methodOptions = cloneDeep(options.filter(option => Object.prototype.hasOwnProperty.call(option, 'object_name'))[0].object_name)
        stepOptions = cloneDeep(options.filter(option => Object.prototype.hasOwnProperty.call(option, 'domain_method_ids'))[0].domain_method_ids)
    } catch (error) {
        console.log('methodOptions stepOptions error', error)
    }

    // console.log('methodOptions', methodOptions)
    // console.log('stepOptions', stepOptions)

    // 方法名称改变
    const handleMethodNameChange = (index, value) => {
        const currentProps = cloneDeep(props)
        currentProps.content.methods[index].method_name = value
        setProps({ ...currentProps })
    }

    // tab栏
    const [openTab, setOpenTab] = useImmer([0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0])
    // 将索引位置的值更改为传入的数字
    const setTab = (ele_i, index) => { setOpenTab(draft => { draft[ele_i] = index }) }

    // 当前选中的参数
    const [openParams, setOpenParams] = useImmer([0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0])
    const setParams = (ele_i, index) => { setOpenParams(draft => { draft[ele_i] = index }) }

    // 当前激活的参数输入框
    const [openInput, setOpenInput] = useImmer([-1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1])
    const setInput = (ele_i, index) => { setOpenInput(draft => { draft[ele_i] = index }) }

    const setInputValue = (ele_i, index, value) => {
        const currentProps = cloneDeep(props)
        currentProps.content.methods[ele_i].params[index].key = value
        setProps({ ...currentProps })
    }

    // 删除参数
    const deleteParam = (ele_i, index) => {
        const currentProps = cloneDeep(props)
        currentProps.content.methods[ele_i].params.splice(index, 1)
        setProps({ ...currentProps })
        setOpenParams(draft => { draft[ele_i] = 0 })
    }

    // 新增参数
    const addParam = (ele_i) => {
        const currentProps = cloneDeep(props)
        const item = {
            key: `param(${currentProps.content.methods[ele_i]?.params?.length + 1})`,
            value: {
                text: '',
                array: [],
                object: {},
                raw: {},
            },
            type: 'text'
        }
        console.log('currentProps.content.methods[ele_i]', currentProps.content.methods[ele_i])
        currentProps.content.methods[ele_i].params.push(item)
        setProps({ ...currentProps })
    }

    // 当前选中的参数
    const [openSteps, setOpenSteps] = useImmer([
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    ])
    const setSteps = (ele_i, ste_i, index) => { setOpenSteps(draft => { draft[ele_i][ste_i] = index }) }

    const tabList = ['params', 'steps']

    // 值列表
    const bodyList = ['text', 'array', 'object', 'raw']

    // 删除方法
    const deleteMethod = (ele_i) => {
        const currentProps = cloneDeep(props)
        currentProps.content.methods.splice(ele_i, 1)
        setProps({ ...currentProps })
    }

    // 新增步骤
    const addStep = (ele_i) => {
        const currentProps = cloneDeep(props)
        const currentStep = {
            method_name: '',
            params: [],
            steps: []
        }
        // 检查 vModel 对象是否有 steps 属性
        if (!Object.prototype.hasOwnProperty.call(currentProps.content.methods[ele_i], 'steps')) {
            // 创建 steps 属性，并赋予一个包含当前方法的数组
            currentProps.content.methods[ele_i].steps = [currentStep]
        } else {
            // 如果 steps 属性已存在，直接将当前方法添加到数组中
            currentProps.content.methods[ele_i].steps.push(currentStep)
        }
        setProps({ ...currentProps })
    }

    // 新增方法
    const addMethod = () => {
        const currentProps = cloneDeep(props)
        const currentMethod = {
            method_name: '',
            params: [],
            steps: []
        }
        // 检查 vModel 对象是否有 methods 属性
        if (!Object.prototype.hasOwnProperty.call(currentProps.content, 'methods')) {
            // 创建 methods 属性，并赋予一个包含当前方法的数组
            currentProps.content.methods = [currentMethod]
        } else {
            // 如果 methods 属性已存在，直接将当前方法添加到数组中
            currentProps.content.methods.push(currentMethod)
        }
        setProps({ ...currentProps })
    }


    const changeType = (event, ele_i, index) => {
        const currentProps = cloneDeep(props)
        if (event.target.value === 'number') {
            if (isNaN(currentProps.content.methods[ele_i].params[index].value.text)) {
                currentProps.content.methods[ele_i].params[index].value.text = 0
            }
            currentProps.content.methods[ele_i].params[index].value.text = Number(currentProps.content.methods[ele_i].params[index].value.text)
        } else if (event.target.value === 'boolean') {
            currentProps.content.methods[ele_i].params[index].value.text = Boolean(currentProps.content.methods[ele_i].params[index].value.text)
        } else {
            currentProps.content.methods[ele_i].params[index].value.text = String(currentProps.content.methods[ele_i].params[index].value.text)
        }
        setProps({ ...currentProps })
    }

    const [isMoving, setIsMoving] = useState(false)
    const [dragIndex, setDragIndex] = useState(0)

    // 开始拖拽时执行 1 次
    const dragstart = (e, index) => {
        e.stopPropagation()
        setDragIndex(index)
        setTimeout(() => {
            setIsMoving(true)
        }, 0)
    }
    // 拖拽元素进入可释放目标时执行 1 次
    const dragenter = (e, ele_i, ste_i) => {
        e.preventDefault()
        const currentProps = cloneDeep(props)
        // 拖拽到原位置时不触发
        if (dragIndex !== ste_i) {
            const source = currentProps.content.methods[ele_i].steps[dragIndex]
            currentProps.content.methods[ele_i].steps.splice(dragIndex, 1)
            currentProps.content.methods[ele_i].steps.splice(ste_i, 0, source)
            // 更新节点位置
            setDragIndex(ste_i)
        }
        console.log('currentProps', currentProps);
        setProps({ ...currentProps })
    }
    // 拖拽元素进入可释放目标时触发多次（100毫秒触发一次）
    const dragover = (e) => {
        e.preventDefault()
        e.dataTransfer.dropEffect = 'move'
    }
    // 拖动结束后触发 1 次
    const dragend = () => {
        setIsMoving(false)
    }

    const setValue = (ele_i, value) => {
        const currentProps = cloneDeep(props)
        currentProps.content.methods[ele_i].method_name = value
        setProps({ ...currentProps })
    }

    const setSelect = (ele_i, value) => {
        const currentProps = cloneDeep(props)
        currentProps.content.methods[ele_i] = value
        setProps({ ...currentProps })
    }

    const setStepValue = (ele_i, ste_i, value) => {
        const currentProps = cloneDeep(props)
        currentProps.content.methods[ele_i].steps[ste_i].method_name = value
        setProps({ ...currentProps })
    }

    const setStepSelect = (ele_i, ste_i, value) => {
        const currentProps = cloneDeep(props)
        currentProps.content.methods[ele_i].steps[ste_i] = value
        setProps({ ...currentProps })
    }

    return (
        <div id={id} className={`${className} h-card h-model`} value={JSON.stringify(content)}>
            <div className="flex items-center gap-4 mb-2">
                <div className="font-semibold text-xl">对象名称</div>
                <input
                    className="form-control flex-1"
                    type="text"
                    disabled={!isEdit}
                    value={content?.object_name}
                    onChange={(e) => {
                        const currentProps = cloneDeep(props)
                        currentProps.content.object_name = e.target.value
                        setProps({ ...currentProps })
                    }}
                />
            </div>

            {content?.methods?.map((ele, ele_i) => (
                <div key={ele_i} className='border relative p-2 my-6 shadow-lg rounded'>
                    {isEdit && <div className='absolute right-1 top-1 cursor-pointer ml-2' onClick={() => deleteMethod(ele_i)}>
                        <DeleteOutlined />
                    </div>}
                    <div className='flex items-center gap-4 pr-8'>
                        <div className='font-semibold text-xl'>方法名称</div>
                        {isEdit ? <Dropdown value={ele?.method_name} options={methodOptions} placeholder='方法名称' setValue={(value) => setValue(ele_i, value)}
                            setSelect={(value) => setSelect(ele_i, value)}></Dropdown> :
                            <input
                                className='form-control flex-1'
                                type="text"
                                disabled={!isEdit}
                                value={ele?.method_name}
                                onChange={e => handleMethodNameChange(ele_i, e.target.value)}
                            />
                        }
                    </div>

                    {/* tab导航 */}
                    <div className='flex gap-1 my-2 text-lg overflow-x-auto overflow-y-hidden border-b'>
                        {tabList.map((item, index) => (
                            <div key={index} className={`cursor-pointer py-1 px-8 whitespace-nowrap -mb-px ${openTab[ele_i] === index ? 'border-b-4 border-b-orange-500 font-semibold' : 'text-gray-500'}`}
                                onClick={() => setTab(ele_i, index)}>
                                {item}
                            </div>
                        ))}
                    </div>

                    {/* params */}
                    <div className={openTab[ele_i] !== 0 && 'hidden'}>
                        <div className='flex items-center my-2 overflow-x-auto overflow-y-hidden border-b'>
                            {content.methods[ele_i]?.params?.map((item, index) => (
                                <div className='params-item whitespace-nowrap -mb-px flex items-center cursor-pointer'>
                                    {isEdit ?
                                        <div onClick={() => setParams(ele_i, index)}
                                            onDoubleClick={() => setInput(ele_i, index)}
                                            className={`ml-3 pl-4 pr-2 py-1 ${openParams[ele_i] === index ? '  border-b-2 border-b-orange-500 font-semibold' : 'text-gray-500'}`}>
                                            {openInput[ele_i] !== index && <div>{item?.key}</div>}
                                            {openInput[ele_i] === index &&
                                                <input className='form-control form-control-sm flex-1' type='text'
                                                    value={item?.key}
                                                    onBlur={() => setInput(ele_i, -1)}
                                                    onKeyUp={(event) => event.key === 'Enter' && setInput(ele_i, -1)}
                                                    onChange={e => setInputValue(ele_i, index, e.target.value)}
                                                ></input>}
                                        </div> :
                                        <div onClick={() => setParams(ele_i, index)}
                                            className={`ml-3 pl-4 pr-2 py-1 ${openParams[ele_i] === index ? '  border-b-2 border-b-orange-500 font-semibold' : 'text-gray-500'}`}>
                                            {item?.key}
                                        </div>}
                                    {isEdit && <div onClick={() => deleteParam(ele_i, index)} className='item-icon text-xs ml-1'> <CloseOutlined /> </div>}
                                    <div className='h-4 border-r ml-2'></div>
                                </div>
                            ))}
                            {isEdit && <div onClick={() => addParam(ele_i)}
                                className='ml-4 min-h-[34px] flex items-center text-gray-400 text-sm cursor-pointer'>
                                <PlusOutlined />
                            </div>}
                        </div>
                    </div>

                    {/* bodyList */}
                    <div className={openTab[ele_i] !== 0 && 'hidden'}>
                        {content.methods[ele_i]?.params?.map((item, index) => (
                            <div className={openParams[ele_i] !== index && 'hidden'}>
                                <div className='mt-1 flex flex-col'>
                                    <div className='flex gap-1 my-2 text-sm overflow-x-auto overflow-y-hidden'>
                                        {bodyList?.map((item1) => (
                                            isEdit ? <div onClick={() => {
                                                const currentProps = cloneDeep(props)
                                                currentProps.content.methods[ele_i].params[index].type = item1
                                                setProps({ ...currentProps })
                                            }} className={`cursor-pointer py-1 px-1  whitespace-nowrap -mb-px flex items-center ${item.type === item1 ? '' : 'text-gray-500'}`}>
                                                <div className={`w-[12px] h-[12px] p-1 border-2 border-gray-300 rounded-full mr-2 ${item.type === item1 ? 'bg-orange-600' : 'text-gray-300'}`}></div>
                                                <div>{item1}</div>
                                            </div> : <div className={`cursor-pointer py-1 px-1  whitespace-nowrap -mb-px flex items-center ${item.type === item1 ? '' : 'text-gray-500'}`}>
                                                <div className={`w-[12px] h-[12px] p-1 border-2 border-gray-300 rounded-full mr-2 ${item.type === item1 ? 'bg-orange-600' : 'text-gray-300'}`}></div>
                                                <div>{item1}</div>
                                            </div>
                                        ))}
                                    </div>

                                    {/* text */}
                                    <div className={item.type === 'text' ? 'input-group mb-3' : 'hidden'}>
                                        <input disabled={!isEdit} value={props.content.methods[ele_i].params[index].value.text}
                                            onChange={e => {
                                                const currentProps = cloneDeep(props)
                                                currentProps.content.methods[ele_i].params[index].value.text = e.target.value
                                                setProps({ ...currentProps })
                                            }} className='form-control form-control-sm w-full' type='text' placeholder='请输入文本' />
                                        <label className="input-group-text">
                                            <select className='form-select form-select-sm'
                                            value={typeof props.content.methods[ele_i].params[index].value.text}
                                            onChange={(e) => changeType(e, ele_i, index)}>
                                            <option disabled value=''>请选择类型</option>
                                            <option>string</option>
                                            <option>number</option>
                                            <option>boolean</option>
                                            </select>
                                        </label>
                                    </div>

                                    {/* array */}
                                    <div className={item.type !== 'array' && 'hidden'}>
                                        <ArrayParams isEdit={isEdit} value={props.content.methods[ele_i].params[index].value.array}
                                            setValue={value => {
                                                const currentProps = cloneDeep(props)
                                                currentProps.content.methods[ele_i].params[index].value.array = value
                                                setProps({ ...currentProps })
                                            }}></ArrayParams>
                                    </div>

                                    {/* object */}
                                    <div className={item.type !== 'object' && 'hidden'}>
                                        <ObjectParams isEdit={isEdit} value={props.content.methods[ele_i].params[index].value.object}
                                            setValue={value => {
                                                const currentProps = cloneDeep(props)
                                                currentProps.content.methods[ele_i].params[index].value.object = value
                                                setProps({ ...currentProps })
                                            }}></ObjectParams>
                                    </div>

                                    {/* raw */}
                                    <div className={item.type !== 'raw' && 'hidden'}>
                                        <Code isEdit={isEdit} value={props.content.methods[ele_i].params[index].value.raw}
                                            setValue={value => {
                                                const currentProps = cloneDeep(props)
                                                currentProps.content.methods[ele_i].params[index].type = 'raw'
                                                currentProps.content.methods[ele_i].params[index].value.raw = value
                                                setProps({ ...currentProps })
                                            }}></Code>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>

                    {/* step导航 */}
                    <div className={openTab[ele_i] !== 1 && 'hidden'}>
                        {props.content.methods[ele_i]?.steps?.map((ste, ste_i) => (
                            <div className='border p-2 my-2 relative'>
                                {isEdit && <div className='absolute right-1 top-1 cursor-pointer ml-2 text-gray-500' onClick={() => {
                                    const currentProps = cloneDeep(props)
                                    currentProps.content.methods[ele_i].steps.splice(ste_i, 1)
                                    console.log('currentProps', currentProps)
                                    setProps({ ...currentProps })
                                }}> <DeleteOutlined /></div>}
                                <div className='flex items-center gap-4 pr-8'>
                                    <div draggable={isEdit}
                                        onDragStart={(e) => dragstart(e, ste_i)}
                                        onDragEnter={(e) => dragenter(e, ele_i, ste_i)}
                                        onDragEnd={(e) => dragend(e)}
                                        onDragOver={(e) => dragover(e)}
                                        className={`font-semibold text-xl cursor-pointer ${isMoving ? 'moving' : ''}`}>步骤名称</div>

                                    {/* <Select
                                        disabled={!isEdit}
                                        className='flex-1'
                                        showSearch
                                        placeholder="请选择方法"
                                        optionFilterProp="children"
                                        onChange={(value) => onChange(ele_i, ste_i, value)}
                                        filterOption={filterOption}
                                        options={newOptions}
                                    /> */}

                                    {isEdit ? <Dropdown value={ele?.steps[ste_i].method_name}
                                        options={stepOptions} placeholder='方法名称'
                                        setValue={(value) => setStepValue(ele_i, ste_i, value)}
                                        setSelect={(value) => setStepSelect(ele_i, ste_i, value)}></Dropdown> :
                                        <input
                                            className='form-control form-control-sm flex-1'
                                            type="text"
                                            disabled={!isEdit}
                                            value={ele?.steps[ste_i].method_name}
                                        />
                                    }
                                </div>
                                {/* tab导航 */}
                                <div className='flex items-center my-2 overflow-x-auto overflow-y-hidden border-b'>
                                    {props.content.methods[ele_i]?.steps[ste_i].params?.map((item, index) => (
                                        <div className='params-item whitespace-nowrap -mb-px flex items-center cursor-pointer'>
                                            <div onClick={() => setSteps(ele_i, ste_i, index)}
                                                className={`ml-3 pl-4 pr-2 py-1 ${openSteps[ele_i][ste_i] === index ? '  border-b-2 border-b-orange-500 font-semibold' : 'text-gray-500'}`}>
                                                {item?.key}
                                            </div>
                                            <div className='h-4 border-r ml-2'></div>
                                        </div>
                                    ))}
                                </div>
                                {props.content.methods[ele_i]?.steps[ste_i].params?.map((item, index) => (
                                    openSteps[ele_i][ste_i] === index && <div key={index}>
                                        {item.type === 'text' && (
                                            <div className='flex gap-2'>
                                                <input disabled={!isEdit} value={props.content.methods[ele_i].steps[ste_i].params[index].value.text}
                                                    onChange={e => {
                                                        const currentProps = cloneDeep(props)
                                                        currentProps.content.methods[ele_i].steps[ste_i].params[index].value.text = e.target.value
                                                        setProps({ ...currentProps })
                                                    }} className='form-control form-control-sm flex-1' type='text' placeholder='请输入文本' />
                                            </div>
                                        )}

                                        {/* array */}
                                        {item.type === 'array' && <div className='flex flex-col'>
                                            <ArrayParams isEdit={isEdit} value={props.content.methods[ele_i].steps[ste_i].params[index].value.array}
                                                setValue={value => {
                                                    const currentProps = cloneDeep(props)
                                                    currentProps.content.methods[ele_i].steps[ste_i].params[index].value.array = value
                                                    setProps({ ...currentProps })
                                                }}></ArrayParams>
                                        </div>}

                                        {/* object */}
                                        {item.type === 'object' && <div className='flex flex-col'>
                                            <ObjectParams isEdit={isEdit} value={props.content.methods[ele_i].steps[ste_i].params[index].value.object}
                                                setValue={value => {
                                                    const currentProps = cloneDeep(props)
                                                    currentProps.content.methods[ele_i].steps[ste_i].params[index].value.object = value
                                                    setProps({ ...currentProps })
                                                }}></ObjectParams>
                                        </div>}

                                        {/* raw */}
                                        {item.type === 'raw' && <div className='flex flex-col'>
                                            <Code isEdit={isEdit} value={props.content.methods[ele_i].steps[ste_i].params[index].value.raw}
                                                setValue={value => {
                                                    const currentProps = cloneDeep(props)
                                                    currentProps.content.methods[ele_i].steps[ste_i].params[index].value.raw = value
                                                    setProps({ ...currentProps })
                                                }}></Code>
                                        </div>}
                                    </div>
                                ))}
                            </div>

                        ))}
                        {isEdit && <div onClick={() => addStep(ele_i)}
                            className='bg-primary text-white border mr-2 px-3 py-2 cursor-pointer rounded-md w-auto inline-flex justify-center items-center'>
                            <PlusOutlined /> 步骤
                        </div>}
                    </div>

                </div>
            ))}

            <div className='my-4 flex gap-2'>
                {isEdit && <button onClick={addMethod} className='bg-primary text-white border px-3 py-2 cursor-pointer rounded-md w-auto inline-flex justify-center items-center'>
                    <PlusOutlined /> 方法
                </button>}
                {children}
            </div>
        </div>
    )
}

Model.defaultProps = {}

Model.propTypes = {
    /**
     * string
     */
    id: PropTypes.any,

    /**
     * string
     */
    className: PropTypes.string,

    /**
     * bool
     */
    isEdit: PropTypes.bool,

    /**
     * object
     */
    content: PropTypes.any,

    /**
     * array
     */
    options: PropTypes.array,

    /**
     * 组件型，按钮内嵌元素
     */
    children: PropTypes.node,

    /**
     * func
     */
    setProps: PropTypes.func
}

export default Model